import React from 'react'

import WebSockets from './WebSockets'

import { useFeedbackModalContext } from '../components/FeedbackModal/context'
import { useCountUnreadMessagesContext } from '../components/LaunchButton/CountUnreadMessages/context'

//TODO remove this when WebSockets will functional component
export const WebSocketsProviders = props => {
  const { unreadMessages, setUnreadMessages } = useCountUnreadMessagesContext()
  const { setFeedbackConfigs, setIsOpenFeedbackModal } =
    useFeedbackModalContext()

  return (
    <WebSockets
      unreadMessages={unreadMessages}
      setFeedbackConfigs={setFeedbackConfigs}
      setUnreadMessages={setUnreadMessages}
      setIsOpenFeedbackModal={setIsOpenFeedbackModal}
      {...props}
    />
  )
}
